import { UserRoles, UserStatus } from '@shared/model/user';
import { StatusTagData } from '../ui/card-user/types';
import { IOption } from '@vtbhome/juicyfront/types';

export const USER_STATUS_MAP: Record<UserStatus, StatusTagData> = {
    active: { variant: 'green', text: 'Активен' },
    disabled: { variant: 'red', text: 'Заблокирован' },
    'waiting-activation': { variant: 'yellow', text: 'В процессе активации' },
};

export const USER_STATUS_OPTIONS: IOption[] = [
    {
        label: 'Активен',
        value: 'true',
    },
    {
        label: 'Заблокирован',
        value: 'false',
    },
];

export const USER_ROLE_OPTIONS: IOption[] = [
    {
        label: 'Сотрудник',
        value: UserRoles.Employee,
    },
    {
        label: 'Менеджер',
        value: UserRoles.Manager,
    },
    {
        label: 'Администратор',
        value: UserRoles.Admin,
    },
];
